var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(-236 -839)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(236 839)",
    fill: "#655744",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-cheap_2",
    d: "M20.284,3A17.284,17.284,0,1,0,37.568,20.284,17.212,17.212,0,0,0,20.284,3ZM19.129,17.208a9.368,9.368,0,0,0,1.92,1.538,9.744,9.744,0,0,1,4.036,2.5,5.41,5.41,0,0,1,1.343,4.036,5.239,5.239,0,0,1-1.343,3.841,5.966,5.966,0,0,1-3.646,1.725v2.881H19.324V30.846a5.71,5.71,0,0,1-3.841-1.92,6.324,6.324,0,0,1-1.538-4.606h3.841a3.749,3.749,0,0,0,.773,2.686,1.863,1.863,0,0,0,1.725.765,1.558,1.558,0,0,0,1.538-.765,2.878,2.878,0,0,0,.578-1.92,3.266,3.266,0,0,0-.578-1.92,6.676,6.676,0,0,0-1.733-1.343,12.314,12.314,0,0,1-4.223-2.5,5.41,5.41,0,0,1-1.343-4.036,5.239,5.239,0,0,1,1.343-3.841,5.966,5.966,0,0,1,3.653-1.725V6.841h2.108V9.917a5.147,5.147,0,0,1,3.458,1.92,6.93,6.93,0,0,1,1.343,4.223H22.4a4.828,4.828,0,0,0-.578-2.5,1.558,1.558,0,0,0-1.538-.765,1.275,1.275,0,0,0-1.343.765,4.776,4.776,0,0,0-.383,1.92A8.987,8.987,0,0,0,19.129,17.208Z",
    transform: "translate(244.717 847.716)",
    fill: "#a99880"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgImg);
export default __webpack_public_path__ + "static/media/svgImg.b22a1a2ebf8890e7f22f3b75658635d6.svg";
export { ForwardRef as ReactComponent };